import * as React from 'react';
import { useSelector, useDispatch } from "react-redux";
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { Actions } from '../Actions';
import { Box, createTheme, ThemeProvider } from '@mui/material';
import { EvidenceWrapper } from '../../components/EvidenceWrapper';
import { CommentsOverviewBox } from '../CommentsOverviewBox';
import { Accordion, AccordionSummary } from '../../common/AccordionsCustomized';
import { ReportComment } from '../ReportComment';
import StatusButton from '../../components/StatusButton';
import { comments } from '../../assets/staticData';
import LicenceStandardsTable from '../../components/LicenceStandardsTable';
import { licenceStandards } from '../../assets/staticData';
import { getClubReviewsInfo, getEvaluationCriteriaStandards, getOnSiteCriteriaStandards, getStandardsEvidences } from '../../api/evaluation';
import ClubStandards from '../ClubStandards';
import EvidenceList from '../../components/EvidenceList';
import { setCriteriaEvidences, setInterviewDetails, setSaEvidences } from '../../redux/reducers/evaluation';
import EvidencesTable from '../../components/EvidencesTable';
import Dragger from '../../components/Dragger';
import { getLicenceStandardsEvidences } from '../../api/licence';
import { setLicenceCriteriaEvidences } from '../../redux/reducers/licence';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import InterviewStandards from '../InterviewStandards';
import { useTranslation } from 'react-i18next';
import ResizableComponent from '../../components/ResizableComponent';
import SplitButton from '../../components/SplitButton';
import { evidenceToStandard, getEvidenceLibrary, uploadFile } from '../../api/evidence';
import EvidencePopup from '../../components/EvidencePopup';
import { evaluationCriteriaActionsRegex, evaluationCriteriaEvidencesRegex, evaluationSelectedCriteriaActionsRegex, evaluationSelectedStandardsActionsRegex, evaluationSelectedStandardsRegex, evaluationSelectedStandardsReportRegex, evaluationStandardsRegex, licenceCriteriaActionsRegex, licenceCriteriaEvidencesRegex, licenceSelectedCriteriaActionsRegex, licenceSelectedStandardsActionsRegex, licenceSelectedStandardsRegex, licenceStandardsRegex, onsiteSelectedCriteriaRegex, onsiteSelectedSessionRegex, onsiteSelectedStandardRegex, onsiteSessionCriteriaRegex, onsiteSessionStandardsRegex } from '../../common/StaticExports';
import { useLocation, useNavigate } from 'react-router';

export default function C7Accordion(props: {data: any, module: String}) {
  const { data, module } = props  
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [isLoadingEvidences, setIsLoadingEvidences] = React.useState(false);
  const currentClub = useSelector((state:any) => state.clubDetails);
  const evalEvidences = useSelector((state:any) => state.evaluation.saCriteriaEvidences);
  const licenceEvidences = useSelector((state:any) => state.licence.criteriaEvidences);
  const currentEvalCriteria = useSelector((state:any) => state.evaluation.selectedSaCriteria);
  const selectedLicenceCriteria = useSelector((state: any) => state.licence.selectedLicenceCriteria);
  const selectedOnSiteSession = useSelector((state: any) => state.evaluation.selectedOnSiteSession);
  const selectedOnSiteCriteria = useSelector((state: any) => state.evaluation.selectedOnSiteCriteria);
  const [t] = useTranslation();
  const fileInputRef:any = React.useRef(null);
  const [isOpenLibModal, setIsOpenLibModal] = React.useState(false);

  const theme = createTheme({
    components: {
      MuiCollapse: {
        styleOverrides: {
          root: {
            height: 'calc(100% - 26px) !important',
          },
          wrapper: {
            height: '100%',
          }
        },
      },
      MuiAccordion: {
        styleOverrides: {
          // root: {
          //   height: expanded == 'panel1' ? '100% !important' : '', 
          // },
          region: {
            height: '100% !important'
          }
        }
      },
      MuiAccordionDetails: {
        styleOverrides: {
          root: {
            height: expanded == 'panel1' ? '100% !important' : '',
          }
        }
      }
    }
  })
  
  const fetchEvidences = async () => {
    setIsLoadingEvidences(true);
    switch(module) {
      case t('EVALUATION'):
        const evalResponse:any = await getEvidenceLibrary('Criteria Evidences', {clubId: currentClub.id, evaluationCriteriaId: currentEvalCriteria?.id, isArchived: false});
        dispatch(setCriteriaEvidences(evalResponse));
        break;
      case t('LICENCE'):
      case 'Licence':
      case 'licence':
        const licenceResponse = await getLicenceStandardsEvidences({standardId: 0, clubId: currentClub.id, criteriaId: selectedLicenceCriteria.id});
        dispatch(setLicenceCriteriaEvidences(licenceResponse));
        break;
    }
    setIsLoadingEvidences(false);
  }

  const [topHeight, setTopHeight] = React.useState(0);
  const [bottomHeight, setBottomHeight] = React.useState(300);
  const containerRef = React.useRef(null);

  const handleMouseDown = (e:any) => {
    setTopHeight(250);
    const startY = e.clientY;
    const startTopHeight = topHeight;
    const startBottomHeight = bottomHeight;

    const handleMouseMove = (moveEvent:any) => {
      const offset = moveEvent.clientY - startY;
      setTopHeight(startTopHeight + offset);
      setBottomHeight(startBottomHeight - offset);
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleFileChange = (e:any) => {    
    const params:any = {
        clubId: currentClub.id,
        standardId: 0,
        file: e.target.files[0],
        standardKind: 0,
        currentFolderId: 0
    }

    const fileUpload = async () => {
        const response = await uploadFile(params);
        return response;
    }

    e.target.files[0] && currentClub.id &&
    fileUpload().then((res) => {
        const tempArr:any = [...(module == t('EVALUATION') ? evalEvidences : licenceEvidences), res];
        dispatch(setSaEvidences(tempArr));
    })
  }

  const manageEvidenceClick = (label:any) => {
    switch(label) {
        case 'Add Evidence':
            fileInputRef.current.click();
            break;
        case 'Add Evidence From Library':
            setIsOpenLibModal(true);
            break;
    }
  }
  const linkLibraryFile = (fileData:any) => {
    const linkToStandard = async () => {
        const response = await evidenceToStandard({fileId: fileData.id, standardId: 0});
        return response;
    }
    linkToStandard().then((res) => {
        const tempArr:any = [...(module == t('EVALUATION') ? evalEvidences : licenceEvidences), res];
        dispatch(setSaEvidences(tempArr));
        setIsOpenLibModal(false);
    })
  }

  const handleChange = (panel:any) => {
    setExpanded(panel);
    switch(module) {
      case t('EVALUATION'):
        if (panel === 'panel1') navigate(`/evaluation/criteria/${currentEvalCriteria?.id}/standards`)
        else if (panel === 'panel2') navigate(`/evaluation/criteria/${currentEvalCriteria?.id}/actions`)
        else if (panel === 'panel3') {navigate(`/evaluation/criteria/${currentEvalCriteria?.id}/evidences`); fetchEvidences();}
        else manageClosePanel();
        break;
      case t('LICENCE'):
      case 'Licence':
      case 'licence':
        if (panel === 'panel1') navigate(`/licence/criteria/${selectedLicenceCriteria?.id}/standards`)
        else if (panel === 'panel2') navigate(`/licence/criteria/${selectedLicenceCriteria?.id}/actions`)
        else if (panel === 'panel3') {navigate(`/licence/criteria/${selectedLicenceCriteria?.id}/evidences`); fetchEvidences();}
        else manageClosePanel();
        break;
      case 'ON_SITE':
      case t('ON_SITE'):
          navigate(`/onsite/sessions/${selectedOnSiteSession?.id}/criteria`);
          break;
    }
  }

  const manageRouteDetails = (currentPanel:any) => {
    switch(module) {
        case t('EVALUATION'):
          return (
            (currentPanel === 'panel1' && (evaluationStandardsRegex.test(location.pathname) || evaluationSelectedStandardsRegex.test(location.pathname) || evaluationSelectedStandardsActionsRegex.test(location.pathname) || evaluationSelectedStandardsReportRegex.test(location.pathname))) ||
            (currentPanel === 'panel2' && (evaluationCriteriaActionsRegex.test(location.pathname) || evaluationSelectedCriteriaActionsRegex.test(location.pathname))) ||
            (currentPanel === 'panel3' && evaluationCriteriaEvidencesRegex.test(location.pathname))
          );
        case t('LICENCE'):
        case 'Licence':
        case 'licence':
          return (
            (currentPanel === 'panel1' && (licenceStandardsRegex.test(location.pathname) || licenceSelectedStandardsRegex.test(location.pathname) || licenceSelectedStandardsActionsRegex.test(location.pathname))) ||
            (currentPanel === 'panel2' && (licenceCriteriaActionsRegex.test(location.pathname) || licenceSelectedCriteriaActionsRegex.test(location.pathname))) ||
            (currentPanel === 'panel3' && licenceCriteriaEvidencesRegex.test(location.pathname))
          );
        default:
        case 'ON_SITE':
        case t('ON_SITE'):
          return (
            (currentPanel === 'panel1' && 
            (onsiteSessionCriteriaRegex.test(location.pathname) ||
             onsiteSelectedCriteriaRegex.test(location.pathname) ||
             onsiteSessionStandardsRegex.test(location.pathname) ||
             onsiteSelectedStandardRegex.test(location.pathname)
            ))
          );
    }
  }

  const manageClosePanel = () => {
    setExpanded(false);
    switch(module) {
        case t('EVALUATION'):
          navigate(`/evaluation/criteria/${currentEvalCriteria?.id}`);
          break;
        case t('LICENCE'):
        case 'Licence':
        case 'licence':
          navigate(`/licence/criteria/${selectedLicenceCriteria?.id}`);
          break;
        case 'ON_SITE':
        case t('ON_SITE'):
            navigate(`/onsite/sessions/${selectedOnSiteSession?.id}`);
            break;
        default:
          break;
    }
  }

  React.useEffect(() => {
    if (
        //evaluation routes
        evaluationStandardsRegex.test(location.pathname) ||
        evaluationCriteriaEvidencesRegex.test(location.pathname) ||
        evaluationCriteriaActionsRegex.test(location.pathname) ||
        evaluationSelectedStandardsRegex.test(location.pathname) ||
        evaluationSelectedStandardsReportRegex.test(location.pathname) ||
        evaluationSelectedCriteriaActionsRegex.test(location.pathname) ||
        evaluationSelectedStandardsActionsRegex.test(location.pathname) ||
        //licence routes
        licenceStandardsRegex.test(location.pathname) ||
        licenceCriteriaEvidencesRegex.test(location.pathname) ||
        licenceCriteriaActionsRegex.test(location.pathname) ||
        licenceSelectedStandardsRegex.test(location.pathname) ||
        licenceSelectedCriteriaActionsRegex.test(location.pathname) ||
        licenceSelectedStandardsActionsRegex.test(location.pathname) ||
        //on-site routes
        onsiteSessionCriteriaRegex.test(location.pathname) ||
        onsiteSelectedCriteriaRegex.test(location.pathname) ||
        onsiteSessionStandardsRegex.test(location.pathname) ||
        onsiteSelectedStandardRegex.test(location.pathname)
            
      ) {
          const tempAccordion = (module !== 'ON_SITE' || module == t('ON_SITE')) ? location.pathname.split('/')[4] : 'standards';
          switch(tempAccordion) {
            case 'standards':
              setExpanded('panel1');
              break;
            case 'actions':
              setExpanded('panel2');
              break;
            case 'evidences':
              setExpanded('panel3');
              break;
          }
        }
  }, [location]);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ height: '100%' }}>
        <Accordion sx={!(expanded === 'panel1' && manageRouteDetails('panel1')) ? { } : { height: 'calc(100% - 64px)' }} expanded={(expanded === 'panel1' && manageRouteDetails('panel1'))} onChange={() => {expanded === 'panel1' ? manageClosePanel() : handleChange('panel1')}}>
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
            <Typography className={'uppercase'} sx={{fontSize: 12}}>Standards and Evaluation</Typography>
          </AccordionSummary>
          <MuiAccordionDetails sx={!(expanded === 'panel1' && manageRouteDetails('panel1')) ? { display: 'none' } : { height: '100%' }}>
            <ResizableComponent/>
          </MuiAccordionDetails>
        </Accordion>
        {
          module != 'ON_SITE' &&
          <>
          <Accordion sx={!(expanded === 'panel2' && manageRouteDetails('panel2')) ? { } : { height: 'calc(100% - 64px)' }} expanded={(expanded === 'panel2' && manageRouteDetails('panel2'))} onChange={() => {expanded === 'panel2' ? manageClosePanel() : handleChange('panel2')}}>
            <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
              <Typography className={'uppercase'} sx={{fontSize: 12}}>Actions</Typography>
            </AccordionSummary>
            <MuiAccordionDetails sx={!(expanded === 'panel2' && manageRouteDetails('panel2')) ? { display: 'none' } : { height: '100%' }}>
              <Actions isOpen={expanded == 'panel2' && manageRouteDetails('panel2')} module={module} />
            </MuiAccordionDetails>
          </Accordion>
          <Accordion sx={!(expanded === 'panel3' && manageRouteDetails('panel3')) ? { } : { height: 'calc(100% - 64px)' }} expanded={(expanded === 'panel3' && manageRouteDetails('panel3'))} onChange={() => {expanded === 'panel3' ? manageClosePanel() : handleChange('panel3')}}>
            <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
              <Typography className={'uppercase'} sx={{fontSize: 12}}>Evidence</Typography>
            </AccordionSummary>
            <MuiAccordionDetails sx={!(expanded === 'panel3' && manageRouteDetails('panel3')) ? { display: 'none' } : { height: '100%' }}>
              <Box sx={{ display: 'block', mt: 2 }}>
                <EvidencesTable data={module == t('EVALUATION') ? evalEvidences : licenceEvidences} isLoading={isLoadingEvidences} isCriteriaLevel={true}/>
              </Box>
            </MuiAccordionDetails>
          </Accordion>
          </>
        }
      </Box>
    </ThemeProvider>
  );
}